module.exports = __webpack_public_path__ + "media/scholarships/calendar-ceb84ca7.svg";